import React, { useState, useMemo, useEffect } from 'react';
import { Button, Card, Col, Container, Form, Modal, Offcanvas, Row, ListGroup, InputGroup } from 'react-bootstrap';
import Breadcrumb from '../../Common/BreadCrumb';
import TableContainer from "../../Common/TableContainer";
import { Link } from 'react-router-dom';
import { useColorlistMutation, useColorDeleteMutation } from "../../Redux/ColorSlice";
import moment from "moment";
import ColorAdd from './ColorAdd';
import { getQueryString } from "../../lib/Validationtext";
import DeleteModal from '../../Common/modals/DeleteModal';
import { toast } from 'react-toastify'

const Color = () => {
  document.title = "Coupons | Toner eCommerce + Admin React Template";
  const [ColorlistFunc, { data: listData, error: listErr, isLoading: listLoading }] = useColorlistMutation();
  const [colorDeleteFunc, { data: deleteData, error: deleteErr, isLoading: deleteLoading, isSuccess: DeleteSuccess }] =
    useColorDeleteMutation();
  const [showModal, setShowModal] = useState(false);
  const [ColorData, setColorData] = useState(false);
  const [showCouponDetails, setShowCouponsDetails] = useState({});
  const [showCoupons, setShowCoupons] = useState(false);
  const [coloradd, setColoradd] = useState(false);
  const [colourGroupname, setColourGroupName] = useState('BLACK');
  const ColorGroupName = ['BLACK', 'YELLOW', 'RED', 'BLUE', 'GREEN', 'ORANGE', 'VIOLET', 'WHITE', 'BROWN', 'PINK'];
  const [page, setPage] = useState(0);
  const [limit, setlimit] = useState(10);

  const CreateColor = () => {
    setColoradd(true)
  };
  useEffect(() => {
    if (DeleteSuccess) {
      setShowModal(false)
      const message = deleteData?.message || "Delete successfully";
      toast.success(message);
      setColorData({})
      // SizelistFunc(getQueryString({ page: page + 1, limit: limit }))

    }
    // if (deleteErr) {
    //     if ('data' in deleteErr) {
    //         const errorData = error;
    //         toast.error(errorData.data.message);

    //     }
    // }
  }, [deleteData, DeleteSuccess, deleteErr]);

  useEffect(() => {
    ColorlistFunc(getQueryString({ page: page + 1, limit: limit, colourGroupName: colourGroupname }))
  }, [page, limit, colourGroupname, DeleteSuccess, coloradd])

  const columns = useMemo(
    () => [
      {
        Header: "Color Name",
        disableFilters: true,
        filterable: true,
        accessor: (cellProps) => {
          return (
            <h5 className="mb-0 fs-16">{cellProps.name}</h5>
          )
        },
      },
      {
        Header: "Color Code",
        accessor: "hexCode",
        disableFilters: true,
        filterable: true,
      },
      {
        Header: "Status",
        disableFilters: true,
        filterable: true,
        accessor: (cellProps) => {
          switch (cellProps.status) {
            case true:
              return (<span className="badge bg-success-subtle text-success text-uppercase"> Active</span>)
            case false:
              return (<span className="badge bg-danger-subtle text-danger text-uppercase"> Inactive</span>)
            default:
              return (<span className="badge bg-success-subtle text-success text-uppercase"> Active</span>)
          }
        },
      },
      {
        Header: "Start Date",
        disableFilters: true,
        filterable: true,
        accessor: (cellProps) => cellProps.createdAt ? moment(cellProps.createdAt).format('DD-MM-YYYY') : '-',
      },

      {
        Header: "End Date",
        accessor: "updatedAt",
        disableFilters: true,
        filterable: true,
        accessor: (cellProps) => cellProps.updatedAt ? moment(cellProps.updatedAt).format('DD-MM-YYYY') : '-',
      },

      {
        Header: "Action",
        disableFilters: true,
        filterable: true,
        accessor: (cellProps) => {
          return (
            <ul className="hstack gap-2 list-unstyled mb-0">
              <li>
                <span data-bs-toggle="offcanvas" className="badge bg-dark-subtle text-dark view-item-btn cursor-pointer" onClick={() => { setShowCouponsDetails(cellProps); setShowCoupons(!showCoupons) }}>View</span>
              </li>
              <li>
                <span className="badge bg-primary-subtle text-primary edit-item-btn cursor-pointer" data-bs-toggle="modal" onClick={() => {
                  CreateColor()
                  setColorData(cellProps)
                }}>Edit</span>
              </li>
              <li>
                <span data-bs-toggle="modal" className="badge bg-danger-subtle text-danger remove-item-btn cursor-pointer" onClick={() => {
                  setColorData(cellProps)
                  setShowModal(!showModal);
                }}>Delete</span>
              </li>
            </ul>
          )
        },
      },




    ], [showCoupons]
  );
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb title="Color" pageTitle="More" />
          <div id="colorlist">
            <Row>
              <Col xxl={12}>
                <Card>
                  <Card.Body>
                    <Row className="align-items-center">
                      <Col xxl={3} md={5}>
                        {/* <div className="search-box mb-3 mb-md-0">
                          <input type="text" className="form-control search" id="searchProductList" placeholder="Search by color code & name..." />
                          <i className="ri-search-line search-icon"></i>
                        </div> */}
                      </Col>

                      <Col className="col-md-auto ms-auto">
                        <Button variant='success'
                          onClick={() => {
                            CreateColor(true)
                            setColorData({})
                          }}
                          className="add-btn"><i className="bi bi-plus-circle me-1 align-middle"></i>Add Color</Button>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            </Row>

            <Row>
              <Col lg={2}>
                <Card elevation={1} className='leftBox'>
                  <Card.Header as="h5">Color Group Name</Card.Header>

                  <ListGroup>
                    {ColorGroupName?.map((color, index) => {
                      return (
                        <ListGroup.Item active={color == colourGroupname && true} onClick={() => { setColourGroupName(color) }}>{color}</ListGroup.Item>
                      )
                    })}
                  </ListGroup>
                </Card>
              </Col>
              <Col lg={10}>
                <Card>
                  <Card.Header as="h5">Color Management</Card.Header>
                  <Card.Body>
                    {coloradd || showCoupons ?
                      <ColorAdd colourGroupname={colourGroupname} coloradd={coloradd} setColoradd={setColoradd} ColorID={ColorData.id} showCouponDetails={showCouponDetails} setShowCoupons={setShowCoupons} showCoupons={showCoupons} />
                      :
                      <>
                        <TableContainer
                          columns={(columns || [])}
                          data={(listData?.response || [])}
                          iscustomPageSize={false}
                          isBordered={false}
                          customPageSize={10}
                          className="custom-header-css table align-middle table-nowrap"
                          tableClass="table-centered align-middle table-nowrap mb-0"
                          theadClass="text-muted table-light"
                          SearchPlaceholder='Search Products...'
                        />
                        <div className="noresult" >
                          <div className="text-center">
                            {
                              listData?.response?.length == 0 &&
                              <h5 className="mt-2">No Result Found</h5>
                            }

                            {/* <p className="text-muted mb-0">We've searched more than 150+ Orders We did not find any orders for you search.</p> */}
                          </div>
                        </div>
                      </>
                    }
                  </Card.Body>
                </Card>
              </Col>
            </Row>
            {showModal && <DeleteModal showModal={showModal} setShowModal={setShowModal} data={ColorData} handleSubmit={() => colorDeleteFunc({ id: ColorData.id })} />}
          </div>
        </Container>
      </div>
    </React.Fragment >
  );
};

export default Color;
